import { selectAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(selectAnatomy.keys);

const outline = definePartsStyle({
  field: {
    background: 'white',
    fontSize: '14px'
  },
  icon: {
    fontSize: '16px'
  }
});

const inline = definePartsStyle({
  field: {
    background: 'transparent',
    border: 0,
    borderRadius: 0,
    height: 'auto',
    width: '100%',
    px: 0,
    paddingInlineEnd: '24px'
  },
  icon: {
    insetEnd: 0,
    position: 'absolute'
  }
});

const sm = definePartsStyle({
  field: {
    borderRadius: 4,
  }
});

const md = definePartsStyle({
  field: {
    borderRadius: 8,
  }
});

export const Select = defineMultiStyleConfig({
  sizes: {
    sm,
    md
  },
  variants: { outline, inline }
});